import { LogoNames, LOGO_NAMES } from '@afterpaytouch/core'

export const isValidLogo = (logo): logo is LogoNames => Object.values(LOGO_NAMES).includes(logo)
